// 账单
export type BillType = {
  "id": number,
  "sid": string
  "outNo": string//报案号
  "license": string

  // 付款模式
  // 0: 仅允许线上支付
  // 1: 仅允许挂帐
  // 2: 允许混合付款，即线上支付+挂帐，只有这种情况下，configs才会生效
  // 3: 不限制
  "mode": 0 | 1 | 2 | 3,
  "totalFee": number,
  "payFee": number,
  //挂帐金额
  "creditFee": number,
  //线上支付状态 [0:默认未支付，1：已支付]
  "payStatus": number,
  //挂帐状态 [0:默认未挂账，1：已挂账]
  "creditStatus": number,
  "createdAt": number
}

// 付款模式
export const BillModes = ["仅允许线上支付", "仅允许挂帐", "挂账+支付", "不限制"];


// 服务项目账单
export type BillItem = {
  "id": number,
  "sid": string
  "itemCode": number,
  "itemId": number,
  "pay": number,
  "credit": number,
  "total": number,
  "starting": number,
  "destination": number,
  "distance": number,
  "createdAt": number,
  "startingStr": string
  "destinationStr": string
  "remark": string
}

// 挂账详情
export type BillCredit = {
  "id": number,
  "sid": string,
  "license": string,
  "provideOutNo": string,
  "totalFee": number,
  "companyId": number,
  "companyName": string,
  "surveyorId": number,
  "surveyorName": string,
  "status": number,
  "remark": string,
  "operatorId": number,
  "operatorName": string,
  "createdAt": number,
  "operatedAt": number
}

// 支付详情
export type BillPayment = {
  "id": number,
  "sid": string,
  "totalFee": number,
  "startedAt": number,
  "outTradeNo": string,//订单编号
  "transactionId": string,//支付编号
  "status":number,//0没有付款
}